/* @flow */
import gql from 'graphql-tag';
import idx from 'idx';
import { graphql } from 'react-apollo';

const query = gql`
  query canMakePhoneCalls {
    me {
      uuid
      permissions {
        canMakePhoneCalls
      }
    }
  }
`;

export const withPhoneCallPermissions = graphql(query, {
  props: ({ data }) => ({
    dataLoading: data.loading,
    canMakePhoneCalls: idx(data, _ => _.me.permissions.canMakePhoneCalls),
  }),
});
